(function () {
  var STORAGE_KEY = 'amProductVariationRing';

  function getLinks(track) {
    return Array.from(track.querySelectorAll('.am-pv-thumb'));
  }

  function moveRing(track, link, animate) {
    var ring = track.querySelector('.am-pv-thumb-ring');
    if (!ring || !link) return;

    var trackRect = track.getBoundingClientRect();
    var linkRect = link.getBoundingClientRect();
    var x = linkRect.left - trackRect.left;
    var y = linkRect.bottom - trackRect.top - 1;

    if (!animate) ring.style.transition = 'none';
    ring.style.width = linkRect.width + 'px';
    ring.style.transform = 'translate(' + x + 'px,' + y + 'px) scaleY(0.5)';
    ring.style.opacity = '1';
    ring.style.visibility = 'visible';

    if (!animate) {
      ring.offsetHeight;
      ring.style.removeProperty('transition');
    }
  }

  function restoreActive(track, animate) {
    moveRing(track, track.querySelector('.am-pv-thumb.active'), animate);
  }

  function readTransition() {
    try {
      var value = JSON.parse(sessionStorage.getItem(STORAGE_KEY));
      sessionStorage.removeItem(STORAGE_KEY);
      return value;
    } catch (error) {
      return null;
    }
  }

  function bindTrack(track, transition) {
    if (track.dataset.amPvRingBound === 'true') return;
    track.dataset.amPvRingBound = 'true';

    var links = getLinks(track);
    var active = track.querySelector('.am-pv-thumb.active');
    if (!links.length || !active) return;

    var shouldTransition =
      transition &&
      transition.path === window.location.pathname &&
      links[transition.fromIndex];

    if (shouldTransition) {
      moveRing(track, links[transition.fromIndex], false);
      requestAnimationFrame(function () {
        requestAnimationFrame(function () {
          moveRing(track, active, true);
        });
      });
    } else {
      moveRing(track, active, false);
    }

    links.forEach(function (link) {
      link.addEventListener('mouseenter', function () {
        moveRing(track, link, true);
      });
      link.addEventListener('focus', function () {
        moveRing(track, link, true);
      });
      link.addEventListener('click', function () {
        var fromIndex = links.indexOf(active);
        try {
          sessionStorage.setItem(
            STORAGE_KEY,
            JSON.stringify({
              path: new URL(link.href, window.location.href).pathname,
              fromIndex: Math.max(0, fromIndex),
            }),
          );
        } catch (error) {}
      });
    });

    track.addEventListener('mouseleave', function () {
      restoreActive(track, true);
    });
    track.addEventListener('focusout', function (event) {
      if (!track.contains(event.relatedTarget)) restoreActive(track, true);
    });

    track.querySelectorAll('img').forEach(function (image) {
      if (!image.complete) {
        image.addEventListener('load', function () {
          restoreActive(track, false);
        });
      }
    });

    if ('ResizeObserver' in window) {
      new ResizeObserver(function () {
        restoreActive(track, false);
      }).observe(track);
    }
  }

  function init(root) {
    var transition = readTransition();
    (root || document).querySelectorAll('.am-pv-thumb-track').forEach(function (track) {
      bindTrack(track, transition);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      init(document);
    });
  } else {
    init(document);
  }

  document.addEventListener('shopify:section:load', function (event) {
    init(event.target);
  });
})();
